import { styled } from "@mui/material/styles";
import { CheckIcon, GlobeIcon, GroupedList, Lede, ListLinesIcon, ListRow, PencilIcon, SectionLabel, SparklesIcon } from "@UI";
import React, { useId } from "react";
import { useTranslation } from "react-i18next";
const PRODUCT_NAME = "JuristIQ";
const SUGGESTIONS = [
    {
        key: "chat.welcome.rephrase",
        Icon: PencilIcon
    },
    {
        key: "chat.welcome.grammar",
        Icon: CheckIcon
    },
    {
        key: "chat.welcome.citations",
        Icon: ListLinesIcon
    },
    {
        key: "chat.welcome.translate",
        Icon: GlobeIcon
    }
];
const Root = styled("div")({
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: "var(--j-sp-6)",
    padding: "var(--j-sp-3)",
    "& > :first-child": {
        marginTop: "auto"
    },
    "& > :last-child": {
        marginBottom: "auto"
    },
    "& > .welcome-head": {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "var(--j-sp-2)",
        textAlign: "center"
    },
    "& .welcome-icon": {
        color: "var(--j-ink-3)"
    },
    "& .welcome-mark": {
        fontSize: "var(--j-fs-2xl)",
        lineHeight: "var(--j-lh-2xl)",
        fontWeight: 600,
        letterSpacing: "-0.006em",
        color: "var(--j-ink)"
    },
    "& > .welcome-try": {
        display: "flex",
        flexDirection: "column",
        gap: "var(--j-sp-3)"
    },
    "& > .welcome-try > [role=group] > *": {
        minHeight: "2.25rem"
    }
});
export function Welcome({ onPick }) {
    const { t } = useTranslation();
    const labelId = useId();
    return /*#__PURE__*/ React.createElement(Root, null, /*#__PURE__*/ React.createElement("div", {
        className: "welcome-head"
    }, /*#__PURE__*/ React.createElement(SparklesIcon, {
        className: "welcome-icon"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "welcome-mark"
    }, PRODUCT_NAME), /*#__PURE__*/ React.createElement(Lede, null, t("chat.question"))), /*#__PURE__*/ React.createElement("div", {
        className: "welcome-try"
    }, /*#__PURE__*/ React.createElement(SectionLabel, {
        id: labelId
    }, t("chat.welcome.try")), /*#__PURE__*/ React.createElement(GroupedList, {
        role: "group",
        "aria-labelledby": labelId
    }, SUGGESTIONS.map(({ key, Icon })=>/*#__PURE__*/ React.createElement(ListRow, {
            key: key,
            icon: /*#__PURE__*/ React.createElement(Icon, null),
            title: t(key),
            titleWeight: 500,
            chevron: true,
            onClick: ()=>onPick(t(key))
        })))));
}
